import { Stack, Typography } from "@mui/material";
import React from "react";
import { RootState } from "../../../../../../redux/store";
import { useSelector } from "react-redux";
import { Checkbox } from "../../../../../global/checkbox/Checkbox";
import { ListingModalSwapLimitReachedItemImage } from "./ListingModalSwapLimitReachedItemImage";
import { ListingModalSwapItemWrapper } from "./ListingModalSwapItemWrapper";
import { useListingModalSwapItemContext } from "./ListingModalSwapItemProvider";
import { useListingModalSwapLimitReachedContext } from "../ListingModalSwapLimitReachedProvider";

export const ListingModalSwapLimitReachedItem = () => {
  const componentColors = useSelector(
    (state: RootState) => state.theme.componentColors,
  );
  const listingItemContext = useListingModalSwapItemContext();
  const listingReturnModalContext = useListingModalSwapLimitReachedContext();

  return (
    <ListingModalSwapItemWrapper>
      <Stack
        direction={"row"}
        sx={{
          borderBottom: "1px solid",
          borderColor: componentColors.outline.outlineVariant,
          backgroundColor:
            listingReturnModalContext.state.listingToReturn?.id ===
            listingItemContext.state.currentListing.id
              ? componentColors.surface.surfContainerHighest
              : "transparent",
        }}
        className="py-[8px] px-[16px] justify-between items-center flex border-b cursor-pointer"
      >
        <Stack direction={"row"} className="space-x-[16px] items-center">
          <ListingModalSwapLimitReachedItemImage
            image={listingItemContext.state.currentListing.coverImage}
          />
          <Stack>
            <Typography
              sx={{ color: componentColors.surface.onSurface }}
              className="text-[16px]"
            >
              {listingItemContext.state.currentListing.title}
            </Typography>
            <Typography
              sx={{ color: componentColors.surface.onSurface }}
              className="text-[14px]"
            >
              {listingItemContext.state.currentListing.user.name}
            </Typography>
          </Stack>
        </Stack>

        <Checkbox
          checked={
            listingReturnModalContext.state.listingToReturn?.id ===
            listingItemContext.state.currentListing?.id
          }
        />
      </Stack>
    </ListingModalSwapItemWrapper>
  );
};
